module.exports = __webpack_public_path__ + "img/t1.66ce6c85.png";